// extracted by mini-css-extract-plugin
export default {"container":"oq-z","brandName":"pq-z","productName":"qq-z","productNamePdpEnhancements":"rq-z","breakLongProductName":"sq-z"};